import utils from '../utils/util';
import orderApi from '../apis/order.api';
import { getVisitInfo } from './order/order.form';

export class OrderService {
  /**
   * 线索站点标识
   */
  constructor(pvAreaId, cityId) {
    this.siteId = 315;
    this.cityId = cityId;
    this.pvAreaId = pvAreaId;
  }
  /**
   * 构建提交表单数据
   * @param orderForm
   * @returns
   */
  buildOrderData(orderForm) {
    const orderData = {
      activityId: 0,
      seriesId: 0,
      orderType: 1,
      phone: '',
      referrer: '',
      currentUrl: '',
      siteId: 0,
      pvSite: 0,
      pvCategory: 0,
      pvSubCategory: 0,
      pvAreaId: 0,
      eid: '',
      userName: '',
      dealerId: 0,
      dealerIds: [],
      productId: 1600,
      leadsType: 1,
      orderSource: 1,
      orderTarget: 1,
      secondType: '',
      brandId: 0,
      factoryId: 0,
      cityId: 0,
      extendedField: '',
      visitInfo: '',
      smsFlag: 1,
      imgCode: '',
      imgGuid: '',
      smsCode: '',
      smsGuid: '',
      deviceId: '',
      salesId: 0,
    };
    orderData.cityId = this.cityId;
    orderData.pvAreaId = this.pvAreaId;

    orderData.dealerId =
      orderForm.dealerIds && orderForm.dealerIds.length > 0
        ? orderForm.dealerIds[0]
        : 0;
    orderData.dealerIds = orderForm.dealerIds;
    orderData.seriesId =
      orderForm.seriesIds && orderForm.seriesIds.length > 0
        ? orderForm.seriesIds[0]
        : 0;
    orderData.phone = orderForm.phone;
    orderData.extendedField = JSON.stringify(orderForm.extendField);

    orderData.imgCode = orderForm.imageVCode;
    orderData.smsCode = orderForm.smsCode;
    orderData.smsGuid = orderForm.smsGuid;

    orderData.siteId = this.siteId;
    orderData.eid = orderForm.elementId;

    orderData.currentUrl = window.location.href;
    orderData.referrer = window.document.referrer;
    orderData.pvSite = window.pvTrack.site;
    orderData.pvCategory = window.pvTrack.category;
    orderData.pvSubCategory = window.pvTrack.subcategory;

    orderData.userName = orderForm.userName;
    orderData.visitInfo = getVisitInfo(
      orderForm.elementId,
      this.pvAreaId.toString(),
    );
    orderData.deviceId = orderForm.deviceId;
    orderData.salesId = orderForm.salesId;
    return orderData;
  }
  createRedPacketOrder(orderForm) {
    const orderData = this.buildOrderData(orderForm);
    orderData.leadsType = 2;
    orderData.siteId = 315;
    const sessionId = utils.getCookie('sessionid').split('||')[0] || '';
    const redPacketOrderData = {
      dealerList: [],
      smsInfo: { smsCode: '', smsGuid: '' },
      sessionId: sessionId,
      deviceToken: orderForm.deviceId === '-1' ? sessionId : orderForm.deviceId,
      ...orderData,
    };
    redPacketOrderData.dealerList = [
      {
        dealerId: orderData.dealerId,
        promotionId: orderForm.promotionId,
        redPacketType: orderForm.redPacketType,
      },
    ];
    redPacketOrderData.smsInfo = {
      smsCode: orderData.smsCode,
      smsGuid: orderData.smsGuid,
    };
    const appId = orderForm.extendField.channelId ? 'vrTake' : 'exhibition';
    return orderApi.createRedPacketOrder(appId, redPacketOrderData);
  }
}
